(ns ballot-scout-v2-frontend.dashboard.views.noty-stats
  (:require
   [ballot-scout-v2-frontend.dashboard.events :as e.dashboard]
   [ballot-scout-v2-frontend.dashboard.subs :as s.dashboard]
   [ballot-scout-v2-frontend.dashboard.views.fragments :as fragments]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]))

(defn subscription-stats
  [{:keys [sms email both]}]
  [:div {:class "subscription stats tile is-vertical"}
   [:div.has-text-centered.has-text-weight-bold [:text "Subscribed Voters"]]
   [:table
    [:tr [:th "Type"] [:th "Voters"]]
    [:tr [:th "Email Only"] [:td email]]
    [:tr [:th "SMS Only"] [:td sms]]
    [:tr.second-to-last-row [:th "Email & SMS"] [:td both]]
    [:tr [:th "Total"] [:td (+ email sms both)]]]])

(defn notification-stats
  [{:keys [sms email]}]
  [:div {:class "notification stats tile is-vertical"}
   [:div.has-text-centered.has-text-weight-bold [:div "Notifications Sent"]]
   [:table
    [:tr [:th "Type"] [:th "Messages"]]
    [:tr [:th "Email"] [:td email]]
    [:tr.second-to-last-row [:th "SMS"] [:td sms]]
    [:tr [:th "Total"] [:td (+ email sms)]]]])

(defn noty-stats-view
  []
  (let [current-route @(rf/subscribe [:ballot-scout-v2-frontend.routes/current-route])
        stats-data @(rf/subscribe [::s.dashboard/noty-stats])
        fetch-error (if @(rf/subscribe [::subs/on-partner-admin-page?])
                      @(rf/subscribe [::request-helpers/failed-request
                                      [::e.dashboard/fetch-noty-stats-for-partner current-route]])
                      @(rf/subscribe [::request-helpers/failed-request
                                      [::e.dashboard/fetch-noty-stats-for-jurisdiction current-route]]))]
    (fragments/title-section
     [:div.home-view.noty-stats
      [:h2.title.heading-2 "Voter Notification Metrics"]
      (cond
        (some? fetch-error)
        [:h4.heading-4.no-data
         "There was an error loading notification data."]

        (= stats-data :loading)
        [:div.loading
         [:img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]]

        (and (map? stats-data) (not-empty stats-data))
        [:div {:class "mt-4 tile is-ancestor"}
         [subscription-stats (:subscriptions stats-data)]
         [notification-stats (:sent stats-data)]]

        :else
        [:h4.heading-4.no-data
         "Waiting for scan data, please check back later."])])))